import React from "react";
import { useTranslation } from "react-i18next";
import noResultLogo from "assets/NoResult.png";
import s from "./NoResult.module.scss";

const NoResult = ({ search }) => {
  const { t } = useTranslation();
  return (
    <div className={s.nodataContainer}>
      <div className={s.nodataContent}>
        <img
          src={noResultLogo}
          alt="No Search Result Logo"
          width={88}
          height={88}
        />
        <div className={s.label}>
          {search
            ? t("component.no.result.no.search.result")
            : t("component.no.result.no.data.found")}
        </div>
      </div>
    </div>
  );
};

export default NoResult;
